import * as React from "react";
import { windowedSlice, humanReadableArray } from "./utils";

interface Session {
  title: string
  time: string
  room: string
}

interface Wifi {
  // undefined なら「提供しません」という形にする
  connection?: {
      ssid: string
      password: string
      // 追加で出したい注意事項など
      caution?: React.JSX.Element
  }
}

const wifi: Wifi = {
  connection: {
      ssid: "here is ssid",
      password: "here is pw",
  }
}

const twitter: {
  hashtags: string[]
} = {
  hashtags: [
    "#hashtag1",
    "#hashtag1",
    "#hashtag1",
    "#hashtag1",
    "#hashtag1",
    "#hashtag1",
  ]
}

const interpretation: {
  rooms: string[]
} = {
  rooms: []
}

const canceledSessions: {
  [key: string]: Session[]
} = {
  Day1: [
    {
      title: "Session Title",
      time: "10:00 - 10:30",
      room: "Room 1",
    }
  ],
  Day2: [],
  Day3: [],
}

const movedSessions: {
  [key: string]: (Session & {toRoom: string})[]
} = {
  Day1: [
    {
      title: "Session Title",
      time: "10:00 - 10:30",
      room: "Room 1",
      toRoom: "Room 2"
    }
  ],
  Day2: [],
  Day3: [],
}

const slideshowItems = [
  // WiFi 情報
  {
    t_i: "zmdi-wifi-alt",
    d: (() => {
      if (wifi.connection) {
        return (
          <div>
            <em>SSID: {wifi.connection.ssid}</em>
            <em>PASS: {wifi.connection.password}</em>
            {wifi.connection.caution && <div style={{ marginTop: "50px", fontSize: "45pt" }}>{wifi.connection.caution}</div>}
          </div>
        )
      } else {
        return (
          <div>
            <p>WiFi is not provided</p>
            <p>WiFiの提供はありません</p>
          </div>
        )
      }
    })()
  },
  // Twitter 情報
  {
    t: <span>#DroidKaigi</span>,
    t_i: "zmdi-twitter",
    d: <table className="hashtag">
      <tbody>
        {windowedSlice(twitter.hashtags, 3).map((r, i) => (<tr key={`twitter-tr-${i}`}>{r.map(tag => (<td key={tag}>{tag}</td>))}</tr>))}
      </tbody>
    </table>
  },
  // バッジ情報
  {
    t_i: <img src="./badge.jpg" style={{ width: "300px" }} />,
    d: <div>
      <p>Please wear your badge inside the venue</p>
      <p style={{ marginTop: "40px" }}>
        会場内では名札を常に着用してください
      </p>
    </div>
  },
  // 撮影注意
  {
    t_i: "zmdi-flash-off",
    d: <div>
      <p>
        Avoid using flash and shutter sounds when taking photos during sessions
      </p>
      <p style={{ marginTop: "20pt" }}>
        セッション中の写真撮影ではフラッシュやシャッター音はお控えください
      </p>
    </div>
  },
  // 同通情報(1/2)
  {
    t_i: "zmdi-translate",
    d: <div>
      <p>
        Sessions with simultaneous interpretation will be in {humanReadableArray(interpretation.rooms, 'en')}.
      </p>
      <p>
      {humanReadableArray(interpretation.rooms, 'ja')}ではセッションの同時通訳が実施されています！
      </p>
    </div>
  },
  // 同通情報(2/2)
  {
    t_i: "zmdi-block",
    d: <div>
      <p>
        Do not take translation receivers outside of the session room.
      </p>
      <p>
        ルーム外への同時通訳レシーバーの持ち出しはご遠慮ください
      </p>
    </div>
  },
  // 飲食情報
  {
    t_i: "zmdi-local-dining",
    d: <div>
      <p>
        No eating or drinking allowed in the lobby or corridors
      </p>
      <p style={{ marginTop: "20pt" }}>
        ロビーと廊下での飲食はご遠慮ください<br />(ルームの中ならOK!)
      </p>
    </div>
  },
  // 展示部屋情報
  {
    t: "Exhibition Room",
    t_i: "zmdi-drink",
    d: <div>
      <p>
        Free coffee, drinks and snacks are available! Also check out Sponsor booths!
      </p>
      <p style={{ marginTop: "10pt" }}>
        飲み物、珈琲、お菓子あります。
        スポンサーブースにもお立ち寄りを
      </p>
    </div>
  },
  // 動画公開情報
  {
    t_i: "zmdi-videocam",
    d: <div>
      <p>
        Session recordings will be available online later.
      </p>
      <p style={{ marginTop: "20pt" }}>
        全セッション動画を後日公開予定です。
      </p>
    </div>
  },
  // キャンセルセッション
  ...Object.keys(canceledSessions).flatMap((day) => {
    const seed = canceledSessions[day];
  
    if (seed.length === 0) {
      console.log(`${day} has no canceled sessions`)
      return [];
    }
  
    // 1ページ辺り最大4個にする
    const pages = windowedSlice(seed, 4);
  
    const showProgress = pages.length > 1;

    return pages.map((sessions, i) => {
      return {
        t: `No show on ${day}${showProgress ? ` (${i}/${pages.length})` : ''}`,
        t_i: "zmdi-alert-circle-o",
        d: (
          <div>
            {sessions.map((session) => {
              return (
                <div key={session.title}>
                  [{session.time}] {session.room} → No Show<br />
                  "{session.title}"
                </div>
              )
            })}
        </div>
        )
      }
    })
  }),
  // 部屋変更セッション
  ...Object.keys(movedSessions).flatMap((day) => {
    const seed = movedSessions[day];
  
    if (seed.length === 0) {
      console.log(`${day} has no moved sessions`)
      return [];
    }
  
    // 1ページ辺り最大4個にする
    const pages = windowedSlice(seed, 4);

    const showProgress = true;// pages.length > 1;
  
    return pages.map((sessions, i) => {
      return {
        t: `Changes on ${day}${showProgress ? ` (${i}/${pages.length})` : ''}`,
        t_i: "zmdi-swap",
        d: (
          <div>
            {sessions.map((session) => {
              return (
                <div key={session.title}>
                  [{session.time}] {session.room} → <strong>{session.toRoom}</strong><br />
                  "{session.title}"
                </div>
              )
            })}
        </div>
        )
      }
    })
  })
];

export default slideshowItems;